export default __webpack_public_path__ + "static/media/Code-Refactoring.622a48a8.png";